import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d.map((x) => `${x.loc?.slice(-1)[0] ?? ""}: ${x.msg.replace("Value error, ", "")}`).join(" · ");
  return fallback;
};

export async function downloadFile(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = filename || (cd.match(/filename="?([^";]+)"?/) || [])[1] || "download";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function blobUrl(path) {
  const res = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}
